import { useSelector } from 'react-redux'

import { getCurrency } from '../selectors/selectors'

const useFormatPrice = () => {
  const currency = useSelector(getCurrency)
  return price => `${price} ${toSign(currency)}`
}

export default useFormatPrice

const toSign = currency => {
  switch (currency) {
    case 'EUR':
      return '€'
    case 'SEK':
      return ':-'
    default:
      throw new Error(`Currency '${currency}' is not supported`)
  }
}
